export const relationshipsToInsured = [
  {
    id: 'Self',
    text: 'Insured',
  },
  {
    id: 'Relative',
    text: 'Relative',
  },
  {
    id: 'Agent',
    text: 'Agent',
  },
  {
    id: 'Attorney',
    text: 'Attorney',
  },
  {
    id: 'contractorvendor_afi',
    text: 'Contractor/Vendor',
  },
  {
    id: 'Employee',
    text: 'Employee',
  },
  {
    id: 'Spouse',
    text: 'Spouse',
  },
  {
    id: 'Claimant',
    text: 'Claimant',
  },
  {
    id: 'claimantatty',
    text: 'Claimant’s Attorney',
  },
  {
    id: 'claimantinsco',
    text: 'Claimant Insurance Co.',
  },
  {
    id: 'domesticpartner',
    text: 'Domestic Partner',
  },
];
